var _ellipse, _ellipse2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_173_1",
    "data-name": "Component 173 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 135,
    height: 133,
    viewBox: "0 0 135 133",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_17",
    "data-name": "Ellipse 17",
    cx: 67.5,
    cy: 66.5,
    rx: 67.5,
    ry: 66.5,
    fill: "#e2e2e2",
    opacity: 0.26
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_19",
    "data-name": "Ellipse 19",
    cx: 59.5,
    cy: 58.5,
    rx: 59.5,
    ry: 58.5,
    transform: "translate(10 8)",
    fill: "#d9d9d9",
    opacity: 0.53
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_4122",
    "data-name": "Path 4122",
    d: "M53.5,0C83.047,0,107,23.505,107,52.5A52.264,52.264,0,0,1,84.667,95.176,53.733,53.733,0,0,1,53.5,105C23.953,105,0,81.495,0,52.5S23.953,0,53.5,0Z",
    transform: "translate(16 14)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Polygon_10",
    "data-name": "Polygon 10",
    d: "M19.455,6.782a4,4,0,0,1,7.09,0l16.4,31.365A4,4,0,0,1,39.4,44H6.6A4,4,0,0,1,3.06,38.147Z",
    transform: "translate(98 44) rotate(90)",
    fill: "#755798"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayButton);
export default __webpack_public_path__ + "static/media/play-button.52dc22db532c1cb8ca5f892794b53cea.svg";
export { ForwardRef as ReactComponent };